import React from "react";
import cls from "classnames";
import { LoadingOutlined } from "@ant-design/icons";
import { isEmpty } from "lodash";
import { Spin } from "antd";
import { useCreation } from "ahooks";
import styles from "./PreviewHistoryListItemStatus.module.scss";
import { PreviewHistoryQrcode } from "./assets/PreviewHistoryQrcodeSVG";
import { PreviewHistoryCopyLink } from "./assets/PreviewHistoryCopyLinkSVG";
import { usePreviewAppStore } from "@custom-hooks/HomeUsePluginRoot/usePreviewAppStore";
import func from "@uikit/func";
import { settings } from "imagica-corekit/dist/base/kernel/Settings";
export interface PreviewHistoryListItemStatusProps {
  id: SortableList.IDType;
  isCodeLodaing: boolean;
  handleCopyLink: (link: string) => void;
  handleQrcode: (link: string) => void;
  clickisDropdownModalOpen: (e: React.MouseEvent<HTMLDivElement>) => void;
}

export function PreviewHistoryListItemStatus(props: PreviewHistoryListItemStatusProps) {
  const { getPublishMetadata } = usePreviewAppStore();
  const { handleCopyLink, handleQrcode, isCodeLodaing } = props;

  const link = getPublishMetadata(props.id)?.link;
  const isPublished = !isEmpty(link);

  const statusWrapperClass = cls(
    styles.statusWrapper,
    isPublished ? styles.statusWrapperPublished : styles.statusWrapperUnPublished
  );

  function onQrcodeClick(e: React.MouseEvent<HTMLDivElement>) {
    e.preventDefault();
    e.stopPropagation();

    if (!link) {
      return;
    }
    handleQrcode(link);
  }

  function onCopyLinkClick(e: React.MouseEvent<HTMLDivElement>) {
    e.preventDefault();
    e.stopPropagation();

    if (!link) {
      func.customMsg({
        content: "Link cannot be empty!",
        type: "info",
      });
      return;
    }
    handleCopyLink(link);
  }

  return (
    <div className={statusWrapperClass}>
      {isPublished ? null : (
        <>
          <div className={styles.status}>{"Never published"}</div>
        </>
      )}
      {isPublished ? (
        <div className={styles.linkAndQrcode}>
          <div className={styles.link} onClick={e => onCopyLinkClick(e)}>
            <PreviewHistoryCopyLink />
            <span>Copy link</span>
          </div>
          <div className={styles.qrcode} onClick={e => onQrcodeClick(e)}>
            {isCodeLodaing ? (
              <Spin indicator={<LoadingOutlined style={{ fontSize: 20 }} spin />} />
            ) : (
              <PreviewHistoryQrcode />
            )}
            <span>QR Code</span>
          </div>
        </div>
      ) : null}

      <div className={styles.dotsBox} onClick={e => props.clickisDropdownModalOpen(e)}>
        <img src={`${settings.S3CDN}${settings.viewAssetsPath}dots.svg`} alt="icon" />
      </div>
    </div>
  );
}
